module.exports = __webpack_public_path__ + "static/media/marker-icon-2x-399a0f.3909d189.png";